import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Box, Grid, Stack, Tab } from '@mui/material';

import React from 'react';

import { useDispatch } from 'react-redux';

import ButtonComp from 'common/components/Button/ButtonComp';
import { StyledTabsList } from 'common/components/TabBar/TabBar';
import { toSentenceCase } from 'common/utils/utilFunctions';

import { setCurrentTab } from '../../common/store/reducer/settingsReducer';

import styles from './TabsLayout.module.scss';

const { focustabColor, tabTextColor } = styles;

type TabsProps = {
	tabs: Array<{
		label: string;
		value: string;
		children: React.ReactNode | React.JSX.Element;
		isEnabled?: boolean;
	}>;
	customClass?: string;
	deleteBtn?: boolean;
	isTabBar?: boolean;
	activetab?: string;
};

const style = {
	'.MuiButtonBase-root.MuiTab-root.Mui-selected': {
		color: focustabColor,
	},
	'.Mui-selected': {
		color: tabTextColor,
	},
};

const TabsLayout: React.FC<TabsProps> = ({
	tabs,
	customClass = undefined,
	deleteBtn = false,
	isTabBar = false,
}) => {
	const dispatch = useDispatch();
	const [value, setValue] = React.useState(tabs[0].value);

	const handleChange = (event: React.SyntheticEvent, newValue: string) => {
		setValue(newValue);
		dispatch(setCurrentTab(newValue));
	};

	return (
		<Box
			className={`${customClass && styles['custom-class']}`}
			data-testid="main-box"
		>
			<TabContext value={value}>
				<Box
					className={`${styles.tabs} ${
						!deleteBtn && !isTabBar && styles['tab-with-border']
					}`}
				>
					<Grid direction="row" container>
						<Grid xs={deleteBtn ? 8 : 12} item>
							<Stack justifyContent="space-between" spacing={2} direction="row">
								{isTabBar ? (
									<StyledTabsList
										onChange={handleChange}
										aria-label="lab API tabs example"
										variant="scrollable"
										scrollButtons={false}
										className={styles.wrap}
										data-testid="tabs-list"
										TabIndicatorProps={{ style: { background: focustabColor } }}
									>
										{tabs.map((tab) => (
											<Tab
												className={styles.tab}
												key={tab.value}
												label={tab.label}
												value={tab.value}
												disableRipple
											/>
										))}
									</StyledTabsList>
								) : (
									<TabList
										onChange={handleChange}
										aria-label="lab API tabs example"
										variant="scrollable"
										scrollButtons={false}
										className={styles.wrap}
										data-testid="tabs-list"
										TabIndicatorProps={{ style: { background: focustabColor } }}
										sx={style}
									>
										{tabs.map((tab) => (
											<Tab
												className={styles.tab}
												key={tab.value}
												label={tab.label}
												value={tab.value}
												disableRipple
											/>
										))}
									</TabList>
								)}
							</Stack>
						</Grid>
						<Grid xs={4} item>
							<Stack alignItems="flex-end">
								{value !== '2' && deleteBtn && (
									<ButtonComp
										btnType="secondary"
										data-testid="delete-btn"
										clickHandler={() => {}}
										disabled
									>
										{toSentenceCase('Delete Jobs')}
									</ButtonComp>
								)}
							</Stack>
						</Grid>
					</Grid>
				</Box>
				<Box>
					{tabs.map((tab) => (
						<TabPanel value={tab.value} key={tab.value} sx={{ padding: '0px' }}>
							{tab.children}
						</TabPanel>
					))}
				</Box>
			</TabContext>
		</Box>
	);
};

export default TabsLayout;
